export default function Desktop(props) {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.25 15L7.5 18L6.5 19H14.5L13.5 18L12.75 15H8.25ZM1.5 11H19.5H1.5ZM3.5 15H17.5C18.0304 15 18.5391 14.7893 18.9142 14.4142C19.2893 14.0391 19.5 13.5304 19.5 13V3C19.5 2.46957 19.2893 1.96086 18.9142 1.58579C18.5391 1.21071 18.0304 1 17.5 1H3.5C2.96957 1 2.46086 1.21071 2.08579 1.58579C1.71071 1.96086 1.5 2.46957 1.5 3V13C1.5 13.5304 1.71071 14.0391 2.08579 14.4142C2.46086 14.7893 2.96957 15 3.5 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
